import { render, staticRenderFns } from "./CommodityFlowAdjustmentList.vue?vue&type=template&id=0c0d2e2e&scoped=true&"
import script from "./CommodityFlowAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./CommodityFlowAdjustmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d2e2e",
  null
  
)

export default component.exports